<template>
  <div class="">
      <!-- Social Media Settings -->

      <br />
      <v-card>

        <v-card-title primary-title>
          <div v-if="hasLinkIcons">
              Your site links to your page on: <SocialMediaLinks :public_settings="public_settings"></SocialMediaLinks>
          </div>
          <div v-else>
                Your site does not link to any social media. Add some to get more visitors!
          </div>
        </v-card-title>

       <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn @click="show = !show" flat color="accent">
           Change Social Media
           <v-icon class="ml-1">{{show ? $vuetify.icons.up : $vuetify.icons.down}}</v-icon>
          </v-btn>
        </v-card-actions>

        <v-slide-y-transition>

          <v-card-text v-show="show">
            <v-form width="100px">

              <LinkChooser baseLink="https://facebook.com/" linkName="facebookLink" :icon="'$vuetify.icons.facebook'"></LinkChooser>
              <LinkChooser baseLink="https://instagram.com/" linkName="instagramLink" :icon="'$vuetify.icons.instagram'" ></LinkChooser>
              <LinkChooser baseLink="https://twitter.com/" linkName="twitterLink" :icon="'$vuetify.icons.twitter'" ></LinkChooser>
              <LinkChooser baseLink="https://youtube.com/" linkName="youtubeLink" :icon="'$vuetify.icons.youtube'" ></LinkChooser>
              <LinkChooser baseLink="https://pinterest.com/" linkName="pinterestLink" :icon="'$vuetify.icons.pinterest'" ></LinkChooser>
              <LinkChooser baseLink="https://vimeo.com/" linkName="vimeoLink" :icon="'$vuetify.icons.vimeo'" ></LinkChooser>

            </v-form>

          </v-card-text>
        </v-slide-y-transition>

      </v-card>
</div>

</template>

<script>

import {mapState} from 'vuex'
// import utils from '../../../utils.ts'
import LinkChooser from './LinkChooser'
import SocialMediaLinks from '../../common/SocialMediaLinks'

export default {
  name: 'SocialMediaSettings',
  components: {
    LinkChooser, SocialMediaLinks
  },
  computed: {
    ...mapState({
      siteName: state => {
        return 'https://smartkidsmarket.com/' + state.admin.userInfo.aid
      },
      facebookLink: state => state.admin.public_settings.facebookLink,
      instagramLink: state => state.admin.public_settings.instagramLink,
      twitterLink: state => state.admin.public_settings.twitterLink,
      youtubeLink: state => state.admin.public_settings.youtubeLink,
      pinterestLink: state => state.admin.public_settings.pinterestLink,
      vimeoLink: state => state.admin.public_settings.vimeoLink,
      public_settings: state => state.admin.public_settings
    }),
    hasLinkIcons () {
      return this.facebookLink || this.instagramLink || this.twitterLink || this.youtubeLink || this.pinterestLink || this.vimeoLink
    }
  },
  data () {
    return {
      show: false,
      inprogress: false,
      updateSuccess: false,
      errMessage: null,
      siteLinks: 'NOT SET YET'

    }
  },

  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
